import { render } from "./ProdVariantValueModal.vue?vue&type=template&id=4742369b&ts=true"
import script from "./ProdVariantValueModal.vue?vue&type=script&lang=ts"
export * from "./ProdVariantValueModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__